import React from 'react';
import { MDBDataTable } from 'mdbreact';
import { TableActionItems } from '../datatable/TableActionItems';
import { CalendarButton } from '../datatable/CalendarButton';
import { CalendarSecondRoundButton } from '../datatable/CalendarRoundTwoButton';
import '../../style/DataTable.css';
import { formatBackendDateEtLocale } from '../../util/dateUtil';

const LeaguesDataTable = (props) => {
  const getLeaguesData = () => {
    let rowData = [];
    props.leagues.map((row) =>
      rowData.push({
        name: row.name ? row.name : 'N/A',
        season: row.seasonStart
          ? formatBackendDateEtLocale(row.seasonStart) +
            ' - ' +
            formatBackendDateEtLocale(row.seasonEnd)
          : 'N/A',
        numberOfTeams: row.teams.length,
        actions: (
          <TableActionItems editAction={() => props.editAction(row.id)} />
        ),
        calendar: (
          <CalendarButton
            hasCalendar={row.hasCalendar}
            numberOfTeams={row.teams.length}
            generateAction={() => props.generateAction(row.id)}
          />
        ),
        calendarSecondRound: (
          <CalendarSecondRoundButton
            hasCalendarSecondRound={row.hasCalendarSecondRound}
            numberOfTeams={row.teams.length}
            generateAction={() => props.generateSecondRoundAction(row.id)}
          />
        ),
      })
    );
    if (!rowData.length) {
      rowData = [{ name: '' }];
    }

    return {
      columns: [
        {
          label: 'Nimi',
          field: 'name',
        },
        {
          label: 'Hooaeg',
          field: 'season',
        },
        {
          label: 'Võistkondade arv',
          field: 'numberOfTeams',
        },
        {
          label: 'Kalender',
          field: 'calendar',
        },
        {
          label: 'Kalender II voor',
          field: 'calendarSecondRound',
        },
        {
          label: '',
          field: 'actions',
        },
      ],
      rows: rowData,
    };
  };
  const tableData = getLeaguesData();

  return (
    <div>
      {tableData ? (
        <MDBDataTable
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          searchLabel={'Otsi'}
          bordered={false}
          paging={!!props.paging}
          searching={!!props.searching}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>Info puudub</div>
      )}
    </div>
  );
};

export default LeaguesDataTable;
